'use strict';
ui.loadTemplateFile('npcstore.html');

const NPCSTORE_TAB_COUNT = 4;

class NpcStoreDialog extends Dialog {
    _element: any;
    _goldLabel: any;
    _tabs: any;
    _tabGrids: any[];
    _closeButton: any;
    _npc: any;
    _tabsData: { name: string; items: any[] }[];

    constructor() {
        super('npcstore.html');

        this._goldLabel = ui.label(this, '.value.gold-amount');
        this._tabs = ui.tabpanel(this, '.tabpanel.mode');

        this._tabGrids = [];
        for (let i = 0; i < NPCSTORE_TAB_COUNT; ++i) {
            this._tabGrids.push(ui.panel(this._tabs.tab(i), '.panel.slots.buy'));
        }

        this._closeButton = ui.button(this, '.button.close');
        this._closeButton.on('clicked', this.close.bind(this));

        this._npc = null;
        this._tabsData = [];

        MC.inventory.on('changed', this._refreshGold.bind(this));
    }

    open(npcObj: any, tabs: { name: string; items: any[] }[]) {
        this._npc = npcObj;
        this._tabsData = tabs;
        this._rebuildTabs();
        this._refreshGold();
        this.show();
        this.center();
    }

    close() {
        this._npc = null;
        this.hide();
    }

    // Called by InventoryDialog's drag/drop handler (see inventory.ts) when an
    // item is dropped on any of this dialog's buy-grid slots, regardless of
    // which tab it's showing -- the store's own catalog tabs replaced the old
    // dedicated Sell tab, so any grid slot doubles as a sell target.
    onItemDroppedOnSell(item: any) {
        if (!this._npc) {
            return;
        }
        const proceed = (quantity: number) => this._confirmSell(item, quantity);
        if (item.quantity > 1) {
            const quantityDialog = ui.quantityDialog(item, { min: 1, max: item.quantity });
            quantityDialog.on('confirm', proceed);
        } else {
            proceed(1);
        }
    }

    // item.slotNo is the wire slot number pakInventory assigns to an
    // INVENTORY-location item (rawIndex - 12) -- +12 recovers the raw
    // owner.items[] index the server's sell handler expects, same
    // conversion vending.ts's onItemDroppedOnSell already makes.
    _confirmSell(item: any, quantity: number) {
        const itemData = GDM.getNow('item_data');
        const name = itemData.getName(item.itemType, item.itemNo);
        const pricePerItem = itemData.getSellValue(item.itemType, item.itemNo, item.durability || 0) || 0;
        const total = pricePerItem * quantity;

        const message = `Sell ${quantity} x ${name} for ${pricePerItem.toLocaleString()} zuly each? Total: ${total.toLocaleString()} zuly`;
        const confirmDialog = ui.messageBox(message, ['Confirm', 'Cancel']);
        confirmDialog.on('confirm', () => {
            netGame.sellStoreItem(this._npc.serverObjectIdx, item.slotNo + 12, quantity);
        });
    }

    _buyItem(entry: any) {
        const isStackable = ITMSTACKABLE[entry.itemType];
        const quantityDialog = ui.quantityDialog(
            { itemType: entry.itemType, itemNo: entry.itemNo, name: entry.name },
            { min: 1, max: isStackable ? 999 : 1 }
        );
        quantityDialog.on('confirm', (quantity: number) => {
            netGame.buyStoreItem(this._npc.serverObjectIdx, entry.itemType, entry.itemNo, quantity);
        });
    }

    _refreshGold() {
        if (!this._npc) {
            return;
        }
        this._goldLabel.text(MC.inventory.money.toString());
    }

    // Rebuilds the tab buttons/grids from this._tabsData. Only called from
    // open(), not on every inventory change, so browsing a tab isn't reset
    // out from under the player every time their inventory updates.
    _rebuildTabs() {
        let slotIndex = 0;
        const itemData = GDM.getNow('item_data');
        for (let i = 0; i < NPCSTORE_TAB_COUNT; ++i) {
            const tabInfo = this._tabsData[i];
            const button = this._tabs.button(i);
            const grid = this._tabGrids[i];
            grid._element.empty();

            if (!tabInfo) {
                button.hide();
                continue;
            }

            button.show();
            button.text(tabInfo.name || 'Store');

            for (const entry of tabInfo.items) {
                const slot = ui.iconslot();
                // New store items come at full durability (the server's
                // getMaxDurability reads the same STB column 8).
                const durability = itemData.getEquipStats(entry.itemType, entry.itemNo).quality;
                slot.setItem({ ...entry, quantity: 1, durability });
                slot.dragEnabled(false);
                slot.appendTooltip('<div class="item value">Price: ' + entry.price.toLocaleString() + ' zuly</div>');
                slot.use = () => this._buyItem(entry);
                // Matches inventory.ts's drag/drop dispatch regex so dropping
                // an inventory item on any buy-grid slot routes to
                // onItemDroppedOnSell, same as vending's fixed slot classes.
                slot._element.addClass('npcstore-buy-slot-' + slotIndex++);
                grid.append(slot);
            }
        }

        const firstVisible = this._tabsData.findIndex((t) => !!t);
        this._tabs.index(firstVisible >= 0 ? firstVisible : 0);
    }
}

ui.NpcStoreDialog = NpcStoreDialog;

ui.npcStoreDialog = () => {
    return new ui.NpcStoreDialog();
};
